import { render, staticRenderFns } from "./AvailableFundsTransfer.vue?vue&type=template&id=e1cb6b60&scoped=true"
import script from "./AvailableFundsTransfer.vue?vue&type=script&lang=js"
export * from "./AvailableFundsTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1cb6b60",
  null
  
)

export default component.exports